import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b15af12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "lading-bill"
}
const _hoisted_3 = { ref: "ref-tab-body" }
const _hoisted_4 = { class: "form-table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_6 = { colspan: "10" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "附件", -1))
const _hoisted_8 = {
  key: 1,
  class: "empty-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_order_detail_company_business_card = _resolveComponent("order-detail-company-business-card")!
  const _component_order_detail_products_summary = _resolveComponent("order-detail-products-summary")!
  const _component_order_detail_container = _resolveComponent("order-detail-container")!
  const _component_order_detail_lading_bill = _resolveComponent("order-detail-lading-bill")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!

  return (_openBlock(), _createBlock(_component_miezz_card, {
    ref: "ref-card",
    title: "分单信息",
    toggle: true,
    down: true,
    topButtons: _ctx.topButtons,
    onHandleHeaderButtonClick: _ctx.handleClick
  }, {
    default: _withCtx(() => [
      (_ctx.tabs.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_tabs, {
              modelValue: _ctx.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id) = $event)),
              type: "card",
              "tab-position": "top",
              onTabClick: _ctx.handleTabClick
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item) => {
                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: item.Id,
                    name: item.Id
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(`${item.Pool?.ClientCompanyNameZh}/${item.Pool?.BookingNo}`), 1),
                      (item.Pool?.DeparturePortLadingBill)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Warning)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onTabClick"]),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.form.Data)
                ? (_openBlock(), _createBlock(_component_el_form, {
                    key: 0,
                    model: _ctx.form.Data,
                    ref: "ruleForm",
                    "label-width": "200px"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_order_detail_company_business_card, {
                          form: _ctx.form,
                          "onUpdate:form": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "Booking No.",
                              prop: "BookingNo"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.form.Data.Pool.BookingNo), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Port of  Loading/装货港",
                              prop: "LoadingPortId"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.form.Data.LoadingPortLabel ?? "暂无数据"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Port of Discharge/卸货港",
                              prop: "DischargePortId"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.form.Data.DischargePortLabel ?? "暂无数据"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Port of Delivery/目的港",
                              prop: "DeliveryPortId"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPortLabel ?? "暂无数据"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Place of Delivery/交货地点",
                              prop: "DeliveryPlaceLabel"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPlaceLabel ?? "暂无数据"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "承运人",
                              prop: "CarrierId"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.form.Data.CarrierLabel ?? "暂无数据"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "合约号",
                              prop: "ContractNo"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.form.Data.ContractNo ?? "暂无数据"), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: "船名",
                                  prop: "ShipName"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.ShipName ?? "暂无数据"), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 1,
                                  label: "航次",
                                  prop: "VoyageNumber"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.VoyageNumber ?? "暂无数据"), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Air)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 2,
                                  label: "航班",
                                  prop: "Flight"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.Flight ?? "暂无数据"), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Railway)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 3,
                                  label: "班次",
                                  prop: "RailwayNumber"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.RailwayNumber ?? "暂无数据"), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_form_item, {
                              label: "装货港ETD",
                              prop: "EstimatedDepartureDate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedDepartureDate)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "装货港ATD",
                              prop: "ActualDepartureDate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.ActualDepartureDate)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "目的港ETA",
                              prop: "EstimatedArrivalDate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedArrivalDate)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "目的港ATA",
                              prop: "ActualArrivalDate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.ActualArrivalDate)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "挂靠码头",
                              prop: "GoodsTransportType"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.form.Data.Dock ?? "暂无数据"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "运费支付方式",
                              prop: "TransportPaymentType"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatTransportPaymentType()), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "运输类型",
                              prop: "GoodsTransportType"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatGoodsTransportType()), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["form"]),
                        _createVNode(_component_order_detail_products_summary, {
                          form: _ctx.form,
                          "onUpdate:form": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form) = $event))
                        }, null, 8, ["form"]),
                        (
                _ctx.form.Data.Pool.TransportContainerLoad ==
                _ctx.EnumTransportContainerLoad.FCL
              )
                          ? (_openBlock(), _createBlock(_component_order_detail_container, {
                              key: 0,
                              form: _ctx.form,
                              "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form) = $event)),
                              showSealNumbers: 
                _ctx.form.Data?.TransportContainerLoad ==
                _ctx.EnumTransportContainerLoad.FCL
              ,
                              departurePortContainer: _ctx.form.Data?.OpenDeparturePortContainer
                            }, null, 8, ["form", "showSealNumbers", "departurePortContainer"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_order_detail_lading_bill, {
                          form: _ctx.form,
                          "onUpdate:form": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form) = $event))
                        }, null, 8, ["form"])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("div", null, [
                            _createVNode(_component_miezz_upload, {
                              modelValue: _ctx.form.Data.Files,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.Files) = $event)),
                              prop: "File",
                              preview: true
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"]))
                : _createCommentVNode("", true)
            ], 512)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, "暂无数据"))
    ]),
    _: 1
  }, 8, ["topButtons", "onHandleHeaderButtonClick"]))
}